import { actionTypes } from './actions';
import { concat, uniq } from 'lodash';

const initialState = {
  errorCodes: [],
};

export default function catchErrorReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CATCH_ERROR:
      return { errorCodes: uniq(concat(state.errorCodes, action.payload)) };
    case actionTypes.CLEAR_ERRORS_STORE:
      return initialState;
    default:
      return state;
  }
}
